import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {CookieService} from "../../services/coockieService/coockie.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";

@Component({
  selector: 'app-bootstrap-alerts',
  templateUrl: './bootstrap-alerts-component.html',
  styleUrls: ['./bootstrap-alerts-component.scss']
})
export class EsBootstrapAlertsComponent implements OnInit {

  public Yiit = Yiit;
  public isDragCopyItemMessage = Yiit.t(window['DRAG_COPY_ITEM_MSG']);

  ngOnInit() {}

  constructor() {}

}
